import React from 'react'
import { Route } from '@fs/zion-router'
import { useEffectiveUser } from '@fs/zion-user'
import LoadingSpinner from './LoadingSpinner'

export default function AuthWithFallbackRoute({ component, fallback, ...props }) {
  const { userLoading, signedIn } = useEffectiveUser()
  if (userLoading) {
    return <LoadingSpinner />
  }
  if (!signedIn) {
    return <Route component={fallback} {...props} />
  }
  return <Route component={component} {...props} />
}
